const vi = {
  // ── Trang Đăng Nhập ──
  login: {
    welcomeBack: 'Chào Mừng Trở Lại',
    createAccount: 'Tạo Tài Khoản',
    signInTitle: 'Đăng nhập vào Trung tâm Điều khiển Bền vững',
    signInDescription: 'Giám sát, phân tích và tối ưu hóa hiệu suất môi trường, năng lượng, an toàn và quản trị trên toàn bộ hoạt động — từ nhà máy đến phòng họp ban lãnh đạo.',
    registerSubtitle: 'Thiết lập quyền truy cập Trung tâm Điều khiển EESG',
    email: 'Email',
    password: 'Mật khẩu',
    fullName: 'Họ và Tên',
    role: 'Vai trò',
    signIn: 'Đăng Nhập',
    create: 'Tạo Tài Khoản',
    pleaseWait: 'Vui lòng đợi...',
    noAccount: 'Chưa có tài khoản?',
    hasAccount: 'Đã có tài khoản?',
    emailPlaceholder: 'bạn@côngty.com',
    passwordPlaceholder: 'Nhập mật khẩu',
    namePlaceholder: 'Nhập tên của bạn',
    heroTitle: 'Trung tâm Điều khiển EESG\n& Bản sao Kỹ thuật số',
    heroDescription: 'Một tầng quyết định tích hợp cho hiệu suất kinh tế, quản lý môi trường, trách nhiệm xã hội và quản trị xuất sắc.',
  },

  // ── Thanh bên ──
  sidebar: {
    cockpit: 'Buồng Điều hành',
    heatmap: 'Bản đồ Nhiệt',
    twin: 'Bản sao Kỹ thuật số',
    emissions: 'Kiểm kê Phát thải',
    oee: 'OEE & Bền vững',
    cbam: 'CBAM',
    reports: 'Trung tâm Báo cáo',
    governance: 'Quản trị',
    alerts: 'Cảnh báo',
    admin: 'Quản trị Hệ thống',
    badge: 'Trung tâm Điều khiển EESG',
    systemStatus: 'Trạng thái Hệ thống',
    allOperational: 'Tất cả hệ thống hoạt động',
    takeTour: 'Tham quan',
  },

  // ── Thanh tiêu đề ──
  header: {
    selectIndustry: 'Chọn Ngành',
    signOut: 'Đăng Xuất',
    industries: {
      'Manufacturing': 'Sản xuất',
      'Oil and Gas': 'Dầu khí',
      'Marine': 'Hàng hải',
      'Built Environment': 'Xây dựng',
      'Materials and Construction': 'Vật liệu & Xây dựng',
    },
  },

  // ── Hướng dẫn Tham quan ──
  tour: {
    welcomeTitle: 'Chào mừng đến SusTek',
    welcomeSubtitle: 'Trung tâm Điều khiển EESG',
    welcomeBody: 'Trung tâm chỉ huy tích hợp của bạn cho hiệu suất môi trường, năng lượng, an toàn và quản trị. Hãy để chúng tôi hướng dẫn bạn qua các mô-đun chính.',
    cockpitTitle: 'Buồng Điều hành',
    cockpitBody: 'Bảng điều khiển vận hành thời gian thực. Giám sát KPI về năng lượng, carbon, nước, an toàn và chi phí — với cảnh báo ngưỡng và phân tích chi tiết theo địa điểm.',
    heatmapTitle: 'Bản đồ Nhiệt Doanh nghiệp',
    heatmapBody: 'Trực quan hóa hiệu suất trên tất cả các địa điểm và ngành một cách nhanh chóng. Phát hiện bất thường, so sánh khu vực và tìm hiểu nguyên nhân gốc.',
    twinTitle: 'Bản sao Kỹ thuật số & AI',
    twinBody: 'Chạy các kịch bản giả định với hỗ trợ AI. Kiểm tra thay đổi giá carbon, cải thiện hiệu quả và thay đổi chuỗi cung ứng — với tư vấn chiến lược từ AI.',
    emissionsTitle: 'Kiểm kê Phát thải',
    emissionsBody: 'Báo cáo đầy đủ theo Nghị định thư GHG cho tất cả 7 loại khí Kyoto trên Phạm vi 1, 2 và 3. Bao gồm định nghĩa ranh giới và theo dõi năm cơ sở.',
    oeeTitle: 'OEE & Bền vững',
    oeeBody: 'Hiệu suất Thiết bị Tổng thể kết hợp với chỉ số bền vững. Ô phân tích chi tiết, phân tích AI, mô phỏng kịch bản tùy chỉnh và ROI danh mục.',
    cbamTitle: 'Tuân thủ CBAM',
    cbamBody: 'Mô-đun Cơ chế Điều chỉnh Biên giới Carbon EU. Theo dõi mức độ phơi nhiễm sản phẩm, tuân thủ nhà cung cấp, khai báo vận chuyển và tạo gói xuất khẩu.',
    reportsTitle: 'Trung tâm Báo cáo',
    reportsBody: 'Tất cả các khung báo cáo bền vững tại một nơi — IFRS S2, GRI, SASB, TNFD, CDP và CBAM. Truy vết bằng chứng và thông tin chi tiết thông minh.',
    industryTitle: 'Chọn Ngành',
    industryBody: 'Chuyển đổi giữa các ngành dọc lập tức. Mỗi ngành có các địa điểm, KPI, kịch bản và tiêu chuẩn riêng phù hợp với bối cảnh vận hành.',
    completeTitle: 'Bạn đã Sẵn sàng',
    completeSubtitle: 'Bắt đầu Khám phá',
    completeBody: 'Bạn đã biết các khu vực chính của Trung tâm Điều khiển. Hãy khám phá dữ liệu và để AI hướng dẫn quyết định của bạn. Bạn có thể bắt đầu lại tham quan bất kỳ lúc nào từ thanh bên.',
    startTour: 'Bắt đầu Tham quan',
    skip: 'Bỏ qua',
    skipTour: 'Bỏ qua tham quan',
    next: 'Tiếp theo',
    back: 'Quay lại',
    getStarted: 'Bắt đầu',
  },

  // ── Buồng Điều hành ──
  cockpit: {
    title: 'Buồng Điều hành',
    subtitle: '{industry} — Tổng quan hiệu suất EESG thời gian thực',
    thresholds: 'Ngưỡng',
    boardPack: 'Gói Báo cáo',
    generating: 'Đang tạo...',
    sites: '{count} địa điểm',
    selectSite: 'Chọn địa điểm để phân tích chi tiết',
    close: 'Đóng',
    energyCarbon: 'Xu hướng Năng lượng & Carbon',
    energyCarbonSub: 'Trung bình 14 ngày — {industry}',
    controlStatus: 'Trạng thái Kiểm soát',
    ebitdaRisk: 'EBITDA có Rủi ro',
    ebitdaRiskSub: 'Mức độ phơi nhiễm hàng năm — {industry}',
    oeeCost: 'Hiệu suất OEE & Chi phí',
    oeeCostSub: 'Hiệu quả vận hành hàng ngày — {industry}',
    activeScenarios: 'Kịch bản Đang hoạt động — {industry}',
    impact: 'Tác động',
    costPerUnit: 'Chi phí/Đơn vị',
    carbonIntensity: 'Cường độ Carbon',
    trir: 'TRIR',
    assuranceCoverage: 'Độ Bảo đảm',
    productionCost: 'Chi phí Sản xuất',
    carbonFootprint: 'Dấu chân Carbon',
    safety: 'An toàn (TRIR)',
    green: 'Xanh',
    amber: 'Vàng',
    red: 'Đỏ',
    energy: 'Năng lượng (MWh)',
    co2: 'CO₂ (tCO₂e)',
    oeePercent: 'OEE %',
    costUnit: 'Chi phí/ĐV',
  },

  // ── Cảnh báo ──
  alerts: {
    title: 'Cảnh báo & Thông báo',
    unread: '{count} cảnh báo chưa đọc cho {industry}',
    markRead: 'Đánh dấu Đã đọc',
    read: 'Đã đọc',
    noAlerts: 'Không có cảnh báo cho ngành này.',
    previouslyRead: 'Đã đọc trước đó',
    critical: 'Nghiêm trọng',
    warning: 'Cảnh báo',
    info: 'Thông tin',
  },

  // ── Quản trị ──
  governance: {
    title: 'Quản trị & Đảm bảo',
    subtitle: 'Kiểm soát, quản lý bằng chứng và theo dõi tuân thủ',
    allStatuses: 'Tất cả',
    open: 'Mở',
    inProgress: 'Đang xử lý',
    closed: 'Đóng',
    noEvents: 'Không tìm thấy sự kiện kiểm soát.',
    controlEvents: 'Sự kiện Kiểm soát',
    filters: 'Bộ lọc',
  },

  // ── Thông báo ──
  notifications: {
    title: 'Thông báo',
    markAllRead: 'Đọc tất cả',
    clearRead: 'Xóa đã đọc',
    all: 'Tất cả',
    unread: 'Chưa đọc',
    critical: 'Nghiêm trọng',
    noNotifications: 'Không có thông báo',
    allCaught: 'Bạn đã cập nhật tất cả',
  },

  // ── Mô-đun OEE ──
  oee: {
    title: 'OEE & Hiệu suất x Bền vững',
    subtitle: 'Phân tích OEE nhà máy, năng lượng, carbon và chi phí',
    tabs: {
      executive: 'KPI Điều hành',
      waterfall: 'Thác nước OEE',
      heatmap: 'Bản đồ Nhiệt',
      initiatives: 'Sáng kiến',
      scenarios: 'Mô phỏng Kịch bản',
      portfolio: 'ROI Danh mục',
      pilot: 'Thí điểm 90 Ngày',
    },
    plantOee: 'Phân tích OEE Nhà máy',
    overallOee: 'OEE Tổng thể',
    availability: 'Khả dụng',
    performance: 'Hiệu suất',
    quality: 'Chất lượng',
    goodUnits: 'Sản phẩm Đạt hôm nay',
    costGoodUnit: 'Chi phí / SP Đạt',
    energyToday: 'Năng lượng Hôm nay',
    co2eGoodUnit: 'CO₂e / SP Đạt',
    scrapRate: 'Tỷ lệ Phế liệu',
    downtimeHours: 'Giờ Ngừng hoạt động',
    waterUsage: 'Sử dụng Nước',
    safetyIncidents: 'Sự cố An toàn',
    aiAssist: 'Hỗ trợ AI',
    drilldown: 'Phân tích Chi tiết',
    customScenario: 'Kịch bản Tùy chỉnh',
    buildScenario: 'Xây dựng Kịch bản',
    runAi: 'Chạy Phân tích AI',
    analyzing: 'Đang phân tích...',
  },

  // ── Kiểm kê Phát thải ──
  emissions: {
    title: 'Kiểm kê Phát thải',
    subtitle: 'Tiêu chuẩn GHG Protocol — 7 Loại khí Nghị định thư Kyoto',
    tabs: {
      overview: 'Tổng quan',
      scope1: 'Phạm vi 1',
      scope2: 'Phạm vi 2',
      scope3: 'Phạm vi 3',
      gases: '7 Loại khí',
      boundary: 'Ranh giới',
    },
    totalEmissions: 'Tổng tCO₂e/năm',
    scope1Label: 'Phạm vi 1',
    scope2Label: 'Phạm vi 2',
    scope3Label: 'Phạm vi 3',
    progressBaseYear: 'Tiến độ so với Năm cơ sở ({year})',
    baseYear: 'Năm Cơ sở',
    current: 'Hiện tại',
    vsBase: 'so với Cơ sở',
    byScope: 'Phát thải theo Phạm vi',
    byGas: 'Phát thải theo Loại khí (tCO₂e)',
    monthlyTrend: 'Xu hướng Phát thải Hàng tháng (tCO₂e)',
    directEmissions: 'Phát thải Trực tiếp',
    indirectEmissions: 'Phát thải Gián tiếp Năng lượng',
    valueChain: 'Phát thải Chuỗi Giá trị',
    gasBreakdown: 'Phân tích Loại khí',
    boundary: 'Ranh giới Tổ chức',
    reportingPeriod: 'Kỳ Báo cáo',
    target: 'Mục tiêu',
    verification: 'Xác minh',
    standards: 'Tiêu chuẩn',
    id: 'Mã',
    category: 'Phân loại',
    description: 'Mô tả',
    gasesCol: 'Loại khí',
    total: 'Tổng',
  },

  // ── Mô-đun CBAM ──
  cbam: {
    title: 'Tuân thủ CBAM',
    subtitle: 'Cơ chế Điều chỉnh Biên giới Carbon EU',
    tabs: {
      executive: 'Điều hành',
      products: 'Sản phẩm',
      suppliers: 'Nhà cung cấp',
      shipments: 'Vận chuyển',
      twin: 'Bản sao Kỹ thuật số',
      compliance: 'Tuân thủ NCC',
    },
  },

  // ── Trung tâm Báo cáo ──
  reports: {
    title: 'Trung tâm Báo cáo',
    subtitle: 'Công bố khung bền vững và quản lý bằng chứng',
    search: 'Tìm kiếm báo cáo...',
    askHub: 'Hỏi Trung tâm',
    frameworks: 'Khung',
    insights: 'Thông tin chi tiết',
    evidence: 'Bằng chứng',
    actions: 'Hành động',
    allFrameworks: 'Tất cả Khung',
  },

  // ── Quản trị Hệ thống ──
  admin: {
    title: 'Quản trị Hệ thống',
    subtitle: 'Đường dữ liệu, lược đồ và quản lý hệ thống',
  },

  // ── Chung ──
  common: {
    loading: 'Đang tải...',
    error: 'Đã xảy ra lỗi',
    retry: 'Thử lại',
    save: 'Lưu',
    cancel: 'Hủy',
    delete: 'Xóa',
    edit: 'Chỉnh sửa',
    view: 'Xem',
    download: 'Tải xuống',
    export: 'Xuất',
    filter: 'Lọc',
    search: 'Tìm kiếm',
    noData: 'Không có dữ liệu',
    total: 'Tổng',
    target: 'Mục tiêu',
    actual: 'Thực tế',
    status: 'Trạng thái',
    date: 'Ngày',
    type: 'Loại',
    output: 'Sản lượng',
  },

  // ── Ngành (tên hiển thị) ──
  industries: {
    'Manufacturing': 'Sản xuất',
    'Oil and Gas': 'Dầu khí',
    'Marine': 'Hàng hải',
    'Built Environment': 'Xây dựng',
    'Materials and Construction': 'Vật liệu & Xây dựng',
  },

  // ── Ngành trang đăng nhập (chân trang) ──
  loginIndustries: ['Sản xuất', 'Dầu khí', 'Hàng hải', 'Xây dựng', 'Vật liệu'],
};

export default vi;
